import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';
import { MenuDirection } from './types';
import Menu from './Menu';
import { ColorTypes } from '../../types';
// @ts-ignore type issues with theme.typography.fontWeightBold and CSSProperties['fontWeight'];
var useStyles = makeStyles(function (theme) { return ({
    buttonLabel: {
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightBold,
        fontSize: theme.typography.fontSize,
        color: theme.palette.common.white,
    },
}); });
/**
 * @deprecated
 * Use `MenuButton` to show a button with label and arrows to open menu or an ellipsis if no label is sent
 */
var MenuButton = function (props) {
    var label = props.label, disabled = props.disabled, items = props.items, menuDirection = props.menuDirection, variant = props.variant, color = props.color, minWidth = props.minWidth, elementId = props.elementId;
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var classes = useStyles(props);
    // handle open close menu
    var handleOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var isOpen = Boolean(anchorEl);
    // get the close icon related to configuration
    var CloseIcon = function () {
        if (menuDirection !== MenuDirection.Above)
            return React.createElement(MdArrowDropUp, { title: 'Close Menu' });
        return React.createElement(MdArrowDropDown, { title: 'Close Menu' });
    };
    // get the open icon related to configuration
    var OpenIcon = function () {
        if (menuDirection !== MenuDirection.Above)
            return React.createElement(MdArrowDropDown, { title: 'Open Menu' });
        return React.createElement(MdArrowDropUp, { title: 'Open Menu' });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { "aria-controls": isOpen ? 'button-menu-opened' : undefined, "aria-haspopup": 'true', disabled: disabled, "data-testid": elementId, variant: variant, color: color, onClick: handleOpen, classes: { label: classes.buttonLabel }, endIcon: isOpen ? React.createElement(CloseIcon, null) : React.createElement(OpenIcon, null) }, label),
        React.createElement(Menu, { menuDirection: menuDirection, items: items, onClose: handleClose, open: isOpen, anchorEl: anchorEl, minWidth: minWidth })));
};
MenuButton.defaultProps = {
    menuDirection: MenuDirection.Default,
    disabled: false,
    variant: 'contained',
    color: ColorTypes.Primary,
    elementId: '',
};
export default MenuButton;
//# sourceMappingURL=MenuButton.js.map